import React from 'react';
import { connect } from 'react-redux';
import { DBTextField, DBCheckBox, DBIntField, DBDateField } from '_components';

class DBField extends React.Component {
    render() {
        switch (this.props.type) {
            case 'bit':
                return (
                    <DBCheckBox {...this.props} />
                );
            case 'varchar':
            case 'char':
                return (
                    <DBTextField {...this.props} />
                )
            case 'int':
                return (
                    <DBIntField {...this.props} />
                )
            case 'datetime':
                return (
                    <DBDateField {...this.props} />
                )
            default:
                return (
                    <DBTextField {...this.props} />
                )
        }
    }
}

function mapStateToProps(state, ownprops) {
    return {
        type: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].DATA_TYPE
    };
}

const connectedDBField = connect(mapStateToProps)(DBField);
export { connectedDBField as DBField };